const GWP_CONFIG = {
  glowSerumHandle: 'glow-serum',
  guaShaHandle: 'gua-sha-stone',
  guaShaVariantId: 47444633452790, // Nephrite Gua Sha — Default Title variant
  discountCode: 'Glow Serum Gua Sha Promo',
  giftPropertyKey: '_gwp_source',
  giftPropertyValue: 'glow-serum-subscription',
};
 
(function () {
  if (!GWP_CONFIG.guaShaVariantId) {
    console.warn('[GWP] guaShaVariantId is not set in GWP_CONFIG — auto gift-with-purchase is disabled.');
    return;
  }
 
  let applying = false;
  let discountApplied = false;
 
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }
 
  function findGlowSerumSubscriptionLine(cart) {
    return cart.items.find(function (item) {
      return item.handle === GWP_CONFIG.glowSerumHandle && !!item.selling_plan_allocation;
    });
  }
 
  function findAutoGuaShaLine(cart) {
    return cart.items.find(function (item) {
      return (
        item.handle === GWP_CONFIG.guaShaHandle &&
        item.properties &&
        item.properties[GWP_CONFIG.giftPropertyKey] === GWP_CONFIG.giftPropertyValue
      );
    });
  }
 
  async function applyDiscountSilently() {
    if (discountApplied) return;
    try {
      await fetch('/discount/' + encodeURIComponent(GWP_CONFIG.discountCode), {
        credentials: 'same-origin',
      });
      discountApplied = true;
    } catch (e) {
      console.error('[GWP] failed to apply discount code', e);
    }
  }
 
  async function addGuaSha() {
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: GWP_CONFIG.guaShaVariantId,
            quantity: 1,
            properties: {
              [GWP_CONFIG.giftPropertyKey]: GWP_CONFIG.giftPropertyValue,
            },
          },
        ],
      }),
    });
    await applyDiscountSilently();
  }
 
  async function removeGuaSha(line) {
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
  }
 
  async function sync() {
    if (applying) return; // guard against overlapping runs
    applying = true;
    try {
      const cart = await getCart();
      const subscriptionLine = findGlowSerumSubscriptionLine(cart);
      const guaShaLine = findAutoGuaShaLine(cart);
 
      if (subscriptionLine && !guaShaLine) {
        await addGuaSha();
        document.dispatchEvent(new CustomEvent('gwp:cart-changed'));
      } else if (!subscriptionLine && guaShaLine) {
        await removeGuaSha(guaShaLine);
        document.dispatchEvent(new CustomEvent('gwp:cart-changed'));
      } else if (subscriptionLine) {
        // Condition still true — make sure the discount is (re)applied, e.g. after
        // a fresh page load where our in-memory "discountApplied" flag has reset.
        await applyDiscountSilently();
      }
    } catch (e) {
      console.error('[GWP] sync failed', e);
    } finally {
      applying = false;
    }
  }
 
  // Run once per page load (cart drawer can be opened from any page).
  document.addEventListener('DOMContentLoaded', sync);
 
  // Re-check after any cart-mutating AJAX call the theme/apps make.
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const isCartWrite = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    const result = origFetch.apply(this, args);
    if (isCartWrite) {
      result.then(function () {
        setTimeout(sync, 50);
      });
    }
    return result;
  };
 
  // Also catch classic (non-AJAX) cart form submissions / full-page cart changes.
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && form.action && /\/cart\/(add|change)/.test(form.action)) {
      setTimeout(sync, 300);
    }
  });
})();